import { AppBar, IconButton, Stack, Toolbar } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { com } from '@eidu/form'
import { useCompactNavigation } from './CompactNavigationContext'
import ActionsMenu from './ActionsMenu'
import { Theme, getThemeConfig } from '../../ui/theme/themeConfig'
import EntityId = com.eidu.sharedlib.entity.EntityId

const DefaultLogo = () => (
  <img src={getThemeConfig('default').logoSrc} className="appBarIcon" alt="" style={{ height: 24 }} />
)

const KenyaMoeLogo = () => <img src={getThemeConfig('kenyaMoe').logoSrc} className="appBarIcon" alt="" />

const AppBarLogo = ({ theme }: { theme: Theme }) => (theme === 'kenyaMoe' ? <KenyaMoeLogo /> : <DefaultLogo />)

export type TopAppBarProps = {
  userEntityId: EntityId | undefined
  signOut?: () => void
  theme?: Theme
}

const TopAppBar = ({ userEntityId, signOut, theme = 'default' }: TopAppBarProps) => {
  const { isCompact, toggleDrawer } = useCompactNavigation()

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        {isCompact ? (
          <Stack
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr auto 1fr',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Stack direction="row" sx={{ alignItems: 'center', justifySelf: 'start' }}>
              <IconButton color="inherit" edge="start" aria-label="Toggle navigation menu" onClick={toggleDrawer}>
                <MenuIcon />
              </IconButton>
            </Stack>
            <Stack direction="row" sx={{ alignItems: 'center', justifySelf: 'center' }}>
              <AppBarLogo theme={theme} />
            </Stack>
            <Stack direction="row" sx={{ alignItems: 'center', justifySelf: 'end' }}>
              <ActionsMenu userEntityId={userEntityId} signOut={signOut} />
            </Stack>
          </Stack>
        ) : (
          <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'left' }}>
              <AppBarLogo theme={theme} />
            </Stack>
            <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'right' }}>
              <ActionsMenu userEntityId={userEntityId} signOut={signOut} />
            </Stack>
          </Stack>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default TopAppBar
